import React from "react";
import ServiceCard from "../Card/ServiceCard";
import { motion } from "framer-motion";
import { FaFileMedical } from "react-icons/fa6";
import {
  FaChartLine,
  FaEnvelope,
  FaHeadset,
  FaUserTie,
  FaLaptopCode,
} from "react-icons/fa";
import bgService from "../../assets/bgservice.png";

const ServiceSection = () => {
  const services = [
    {
      id: 1,
      icon: <FaFileMedical fontSize={40} />,
      title: "Medical Virtual Assistance",
      content:
        "Patient scheduling and appointment coordination, insurance verification and eligibility checks, documentation and chart management, prior authorizations and referrals",
    },
    {
      id: 2,
      icon: <FaChartLine fontSize={40} />,
      title: "Social Media Management & SEO",
      content:
        "End-to-end social media management services, including content planning and scheduling, post creation and caption writing, engagement and community management, and analytics tracking with performance reporting.",
    },
    {
      id: 3,
      icon: <FaEnvelope fontSize={40} />,
      title: "Internal Campaign Management",
      content:
        "Campaign planning and execution, Email and SMS campaigns, lead tracking and follow-ups",
    },
    {
      id: 4,
      icon: <FaHeadset fontSize={40} />,
      title: "Customer Service Support",
      content:
        "Email, chat, and phone support, inquiry handling and issue resolution, customer satisfaction monitoring",
    },
    {
      id: 5,
      icon: <FaUserTie fontSize={40} />,
      title: "General Virtual Assistance",
      content:
        "Administrative support and data entry, calendar and inbox management, research and reporting, file organization and documentation, task and workflow management",
    },
    {
      id: 6,
      icon: <FaLaptopCode fontSize={40} />,
      title: "Web Design & Website Support",
      content:
        "Website design and layout creation, landing page design for campaigns, website updates and maintenance, content upload and formatting, basic SEO structure setup, mobile responsiveness optimization",
    },
  ];

  return (
    <div
      id="service"
      className="bg-primary text-primary py-16 px-5 md:px-10"
      style={{
        backgroundImage: `url(${bgService})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          {/* H1 Animation */}
          <motion.h1
            className="text-3xl md:text-4xl font-bold text-primary"
            initial={{ opacity: 0, y: -80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            How We Support Your Business
          </motion.h1>

          {/* P Animation */}
          <motion.p
            className="text-black mt-2 text-lg"
            initial={{ opacity: 0, y: -40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Comprehensive virtual assistance solutions tailored to your needs
          </motion.p>
        </div>

        {/* Cards Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.8 }}
          viewport={{ once: true }}
        >
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              icon={service.icon}
              title={service.title}
              content={service.content}
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ServiceSection;
